import { useResultData } from '../../context';
import { tokens } from '../../tokens';

const Masthead = () => {
  const displayData = useResultData();
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        gap: 8,
        maxWidth: 1400,
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 20,
      }}
    >
      <div
        style={{
          fontSize: 12,
          color: tokens.textSecondary,
          textTransform: 'uppercase',
          letterSpacing: '0.3em',
        }}
      >
        Strategy Performance Report
      </div>
      <div
        style={{
          fontSize: 12,
          color: tokens.textSecondary,
          fontFamily: tokens.fontMono,
          letterSpacing: '0.1em',
        }}
      >
        {displayData.headerDate} · {displayData.assetPair}
      </div>
    </div>
  );
};

export default Masthead;
